import { Col, Row, Form, Carousel } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { COUNTRYWITHCODE_API, FRANCHISE_API, FRANCHISE_ENQUIRY_API } from "../../config/config";
import * as Yup from "yup";
import { Formik } from "formik";
import sendenquiryproductpage from "../../assets/images/sendenquiryproductpage.webp";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";


const FranchiseModel = ({ show, handleClose }) => {
    const [data, setData] = useState({ franchise: [] });
    const [imgLoaded, setImgLoaded] = useState(false);
    const [countries, setCountries] = useState([]);


    const fetchFranchiseData = async () => {
        try {
            const response = await axios.get(FRANCHISE_API);
            const result = response?.data;
            setData({ franchise: result?.franchise || [] });
        } catch (error) {
            console.error("Error fetching FranchiseData::", error);
        }
    }

    const fetchCountry = async () => {
        try {
            const response = await axios.post(COUNTRYWITHCODE_API);
            setCountries(response.data.DATA);
        } catch (error) {
            console.error("Error fetching country data:", error);
        }
    };

    useEffect(() => {
        if (show) {
            fetchFranchiseData();
            fetchCountry();
        }
    }, [show]);


    return (
        <>
            <Modal
                show={show}
                onHide={handleClose}
                className="p-3 enquirymodel"
                dialogClassName="no-radius-modal"
                centered
                style={{ borderRadius: "0px" }}
            >
                <Modal.Header
                    closeButton
                    className="py-2 them-color border-0 justify-content-center position-relative send-header"
                    closeVariant={"white"}
                >
                    <Modal.Title className="px-3 px-sm-0  w-100 text-start h5">
                        <span className="text-start them-font text-light">{data?.franchise[0]?.enquiry_title}</span>
                    </Modal.Title>
                </Modal.Header>
                <Row className="">
                    <Col lg={6} md={6} sm={6} xs={12} className="p-0">
                        {!imgLoaded && (
                            <p>Loading...</p>
                        )}
                        <img
                            src={data?.franchise[0]?.enquiry_image}
                            alt="enquiry_image"
                            className="p-2 rounded-4 w-100 franch-enquiry_image"
                            onLoad={() => setImgLoaded(true)}
                            style={{ opacity: imgLoaded ? 1 : 0 }}
                        />
                        {data?.franchise[0]?.enquiry_description && (
                            <div className="them-font p-2 pt-0">
                                <b>{data?.franchise[0]?.enquiry_description}</b>
                            </div>
                        )}
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={12}>
                        <div className="mt-0 mt-md-3 pb-2">
                            <p className="fs-6 fw-semibold mb-2">
                                Our team will reach out to you within the next 24 hours.
                            </p>
                            <Formik
                                initialValues={{
                                    fullName: "",
                                    email: "",
                                    contact_number: "",
                                    country: "",
                                    state: "",
                                    city: "",
                                    pincode: "",
                                }}
                                validationSchema={Yup.object({
                                    fullName: Yup.string().required("Full name is required"),
                                    email: Yup.string()
                                        .email("Invalid email address")
                                        .required("Email is required"),
                                    contact_number: Yup.string()
                                        .matches(/^\d{10}$/, "Must be exactly 10 digits")
                                        .required("Mobile number is required"),
                                    country: Yup.string().required("Country is required"),
                                    state: Yup.string().required("State is required"),
                                    city: Yup.string().required("City is required"),
                                    pincode: Yup.string()
                                        .matches(/^\d{6}$/, "Pincode must be 6 digits")
                                        .required("Pincode is required"),
                                })}
                                onSubmit={async (values, { setStatus, resetForm }) => {
                                    try {
                                        const payload = {
                                            full_name: values.fullName,
                                            email: values.email,
                                            mobile_no: values.contact_number,
                                            country: values.country,
                                            state: values.state,
                                            city: values.city,
                                            pincode: values.pincode,
                                        };

                                        const response = await axios.post(FRANCHISE_ENQUIRY_API, payload);
                                        setStatus({ success: response.data.message });
                                        resetForm();
                                        handleClose();
                                        toast.success(response.data.message || "Form submitted successfully!");

                                    } catch (error) {
                                        setStatus({ error: "Error submitting the form" });
                                        console.error("Error submitting form:", error);
                                        toast.error("Form submit Error!", error);

                                    }
                                }}

                            >
                                {({
                                    handleSubmit,
                                    handleChange,
                                    handleBlur,
                                    values,
                                    touched,
                                    errors,
                                    status,
                                }) => (
                                    <Form onSubmit={handleSubmit} className="d-flex flex-column gap-0 gap-md-2 send-modal">
                                        <Form.Group className="mb-2" controlId="fullName">
                                            <Form.Control
                                                type="text"
                                                name="fullName"
                                                placeholder="Full Name"
                                                className="theme-shadow"
                                                value={values.fullName}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={touched.fullName && errors.fullName}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.fullName}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group className="mb-2" controlId="email">
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                placeholder="Email Address"
                                                className="theme-shadow"
                                                value={values.email}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={touched.email && errors.email}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.email}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group className="mb-2" controlId="contact_number">
                                            <Form.Control
                                                type="text"
                                                name="contact_number"
                                                placeholder="Mobile No"
                                                className="theme-shadow"
                                                value={values.contact_number}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                                                    handleChange({
                                                        target: { name: "contact_number", value },
                                                    });
                                                }}
                                                onBlur={handleBlur}
                                                inputMode="numeric"
                                                maxLength={10}
                                                isInvalid={touched.contact_number && errors.contact_number}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.contact_number}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        {/* <Form.Group className="mb-2" controlId="country">
                                            <Form.Control
                                                type="text"
                                                name="country"
                                                placeholder="Country"
                                                className="theme-shadow"
                                                value={values.country}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={touched.country && errors.country}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.country}
                                            </Form.Control.Feedback>
                                        </Form.Group> */}
                                        <Form.Group className="mb-3" controlId="formCountry">
                                            <Form.Select
                                                as="select"
                                                name="country"
                                                value={values.country}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={touched.country && errors.country}
                                                className="theme-shadow"
                                            >
                                                <option value="">Select your country</option>
                                                {countries.map((country) => (
                                                    <option
                                                        key={country.id}
                                                        value={`${country.phonecode.replace("+", "")} ${country.country_name}`}
                                                    >
                                                        {country.phonecode} {country.country_name}
                                                    </option>

                                                ))}
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">
                                                {errors.country}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group className="mb-2" controlId="state">
                                            <Form.Control
                                                type="text"
                                                name="state"
                                                placeholder="State"
                                                className="theme-shadow"
                                                value={values.state}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={touched.state && errors.state}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.state}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group className="mb-2" controlId="city">
                                            <Form.Control
                                                type="text"
                                                name="city"
                                                placeholder="City"
                                                className="theme-shadow"
                                                value={values.city}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={touched.city && errors.city}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.city}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group className="mb-2" controlId="pincode">
                                            <Form.Control
                                                type="text"
                                                name="pincode"
                                                placeholder="Pincode"
                                                className="theme-shadow"
                                                value={values.pincode}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                                                    handleChange({ target: { name: "pincode", value } });
                                                }}
                                                onBlur={handleBlur}
                                                isInvalid={touched.pincode && errors.pincode}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.pincode}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <div className="d-flex justify-content-end">
                                            <button
                                                className="rounded-5 px-4 py-2 reachus-btn btn-red-to-black-color-move"
                                                type="submit"
                                            >
                                                <span>Submit</span>
                                            </button>
                                        </div>

                                        {status?.success && (
                                            <div className="text-success text-center mt-2">{status.success}</div>
                                        )}
                                        {status?.error && (
                                            <div className="text-danger text-center mt-2">{status.error}</div>
                                        )}
                                    </Form>
                                )}
                            </Formik>

                        </div>
                    </Col>
                </Row>
            </Modal>
        </>
    );
};

export default FranchiseModel;
